import { api } from "@/comn";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { TGridSchema } from "@/comn/hooks";
import { TFormSchema } from "@/comn/hooks";

export const BASE = {
    path: `${process.env.REACT_APP_BASE}`,
    nodes: [],
};

export const APIS = {
    getApcMgmtList: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "apcCd",
            page: page,
            size: size,
            keyword: data.apcCd,
            keywordName: data.apcDesc,
        });
    },

    getEpcMgmtList: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "epcCd",
            page: page,
            size: size,
            keyword: data.epcCd,
            keywordName: data.epcDesc,
        });
    },

    getUcrNoList: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "ucrNo",
            page: page,
            size: size,
            keyword: data.ucrNo,
            param1: data.ucrRegmCd,
            param2: data.exppnNm,
            param3: data.exppnTin,
            param4: data.imppnNm,
            param5: data.imppnTin,
            param6: data.lpcoUseYn,
            param7: data.tansadUseYn,
        });
    },
    getTinNoLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "tinNo",
            page: page,
            size: size,
            keyword: data.tinNo,
            keywordName: data.coNm,
        });
    },

    getWrhsCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "wrhsCd",
            page: page,
            size: size,
            keyword: data.coDclaCd,
            keywordName: data.wrhsNm,
            param1: data.wrhsOprtTpCd,
            param2: data.cstmOfceCd,
        });
    },

    getTrmnlOptrCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "trmnlOptrCd",
            page: page,
            size: size,
            keyword: data.trmnlOptrCd,
            keywordName: data.trmnlOptrNm,
        });
    },

    getCarrCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "carrCd",
            page: page,
            size: size,
            keyword: data.coDclaCd,
            keywordName: data.carrNm,
        });
    },

    getComnCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            comnCd: data.comnCd,
            area: "comnCd",
            page: page,
            size: size,
            keyword: data.cdVldVal,
            keywordName: data.cdVldValNm,
            langCd: data.langCd,
        });
    },

    getCityCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "cityCd",
            page: page,
            size: size,
            keyword: data.regnCd,
            keywordName: data.regnNm,
            param1: data.cntyCd,
            param2: data.cntyCdArr,
            param3: data.regnTpCd,
        });
    },

    getPortCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "portCd",
            page: page,
            size: size,
            keyword: data.regnCd,
            keywordName: data.regnNm,
            param1: data.cntyCd,
            param2: data.cntyCdArr,
        });
    },

    getCntyCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "cntyCd",
            page: page,
            size: size,
            keyword: data.cntyCd,
            keywordName: data.cntyNm,
        });
    },
    getDgt3CntyCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "dgt3CntyCd",
            page: page,
            size: size,
            keyword: data.dgt3CntyCd,
            keywordName: data.cntyNm,
        });
    },
    getDgt3NumCntyCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "dgt3NumCntyCd",
            page: page,
            size: size,
            keyword: data.dgt3NumCntyCd,
            keywordName: data.cntyNm,
        });
    },
    getCurrCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "currCd",
            page: page,
            size: size,
            keyword: data.currCd,
            keywordName: data.currNm,
        });
    },
    getBnkCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "bnkCd",
            page: page,
            size: size,
            keyword: data.cdVldVal,
            keywordName: data.cdVldValNm,
        });
    },
    getPortAirptCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "portAirptCd",
            page: page,
            size: size,
            keyword: data.regnCd,
            keywordName: data.regnNm,
            param1: data.portAirptTpCd,
            param2: data.cntyCd,
            param3: data.cntyCdArr,
        });
    },
    getAirptCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "airptCd",
            page: page,
            size: size,
            keyword: data.regnCd,
            keywordName: data.regnNm,
            param1: data.cntyCd,
            param2: data.cntyCdArr,
        });
    },
    getCoCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "coCd",
            page: page,
            size: size,
            keyword: data.coTin,
            keywordName: data.coNm,
            param1: data.coTpCd,
        });
    },
    getPrcssStatCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "prcssStatCd",
            page: page,
            size: size,
            keyword: data.item,
            keywordName: data.itemNm,
        });
    },
    getOrgCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "orgCd",
            page: page,
            size: size,
            keyword: data.orgCd,
            keywordName: data.orgNm,
            param1: data.lpcoIssuYn,
        });
    },
    getCoDclaCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "coDclaCd",
            page: page,
            size: size,
            keyword: data.coCd,
            keywordName: data.coNm,
            param1: data.coTin,
            param2: data.coTpCd,
            param3: data.spcdlWrhsYn,
            param4: data.coCds,
        });
    },
    getOrgDeptCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "orgDeptCd",
            page: page,
            size: size,
            keyword: data.deptCd,
            keywordName: data.deptNm,
            param1: data.orgCd,
            param2: data.orgNm,
        });
    },

    getCstmCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "cstmCd",
            page: page,
            size: size,
            keyword: data.cstmOfceCd,
            keywordName: data.cstmNm,
            param1: data.cstmTpCd,
            param2: data.dclrYn,
            param3: data.cstmOfceCdArr,
        });
    },

    getCstmOfcrCdList: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "cstmOfcrCd",
            page: page,
            size: size,
            keyword: data.usrNm,
            keywordName: data.cstmOfceCd,
            param1: data.usrDmnId,
            param2: data.usrStatCd,
            param3: data.roleId,
        });
    },

    getVhclBodyCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclBodyCd",
            page: page,
            size: size,
            keyword: data.vhclBodyTpCd,
            keywordName: data.vhclBodyTpNm,
        });
    },

    getVhclCtgrCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclCtgrCd",
            page: page,
            size: size,
            keyword: data.vhclCtgrCd,
            keywordName: data.vhclCtgrNm,
        });
    },

    getVhclClrCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclClrCd",
            page: page,
            size: size,
            keyword: data.vhclClrCd,
            keywordName: data.vhclClrNm,
        });
    },

    getVhclFlCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclFlCd",
            page: page,
            size: size,
            keyword: data.vhclFlTpCd,
            keywordName: data.vhclFlNm,
        });
    },

    getVhclMkerCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclMkerCd",
            page: page,
            size: size,
            keyword: data.vhclMkerCd,
            keywordName: data.vhclMkerNm,
        });
    },

    getVhclImpCntyCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclImpCntyCd",
            page: page,
            size: size,
            keyword: data.vhclCntyCd,
            keywordName: data.vhclCntyNm,
        });
    },

    getVhclInsrTpCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclInsrTpCd",
            page: page,
            size: size,
            keyword: data.vhclInsrTpCd,
            keywordName: data.vhclInsrTpNm,
        });
    },

    getVhclMdlCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclMdlCd",
            page: page,
            size: size,
            keyword: data.vhclMdlCd,
            keywordName: data.vhclMdlNm,
            param1: data.vhclMkerCd,
        });
    },

    getVhclMdlNoCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclMdlNoCd",
            page: page,
            size: size,
            keyword: data.vhclMdlNoCd,
            keywordName: data.vhclMdlNoNm,
            param1: data.vhclMkerCd,
            param2: data.vhclMdlCd,
        });
    },

    getVhclHlpnCtgrCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclHlpnCtgrCd",
            page: page,
            size: size,
            keyword: data.vhclHlpnCtgrCd,
            keywordName: data.vhclHlpnCtgrNm,
        });
    },

    getVhclPrplTpCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclPrplTpCd",
            page: page,
            size: size,
            keyword: data.vhclPrplTpCd,
            keywordName: data.vhclPrplTpNm,
        });
    },

    getVhclTrmssnTpCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclTrmssnTpCd",
            page: page,
            size: size,
            keyword: data.vhclTrmssnTpCd,
            keywordName: data.vhclTrmssnTpNm,
        });
    },

    getVhclUseCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "vhclUseCd",
            page: page,
            size: size,
            keyword: data.vhclUseCd,
            keywordName: data.vhclUseNm,
        });
    },

    getCoCdDtl: (data: any) => {
        return api.get(`${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/comnppup/co/${data}`);
    },

    getHsCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "hsCdPopup",
            page: page,
            size: size,
            keyword: data.hsCd,
            keywordName: data.hsDesc,
            param1: data.hsDgt,
        });
    },

    getPostCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "postCd",
            page: page,
            size: size,
            keyword: data.postCd,
            keywordName: data.postNm,
            param1: data.postTpCd,
        });
    },

    getTbLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "tb",
            page: page,
            size: size,
            keyword: data.tbId,
            keywordName: data.tbNm,
        });
    },

    getIndvCdTbLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "indvCdTb",
            page: page,
            size: size,
            keyword: data.tbId,
            keywordName: data.tbNm,
        });
    },

    getColLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "col",
            page: page,
            size: size,
            keyword: data.colId,
            keywordName: data.colNm,
            param1: data.tbId,
        });
    },

    getIndvCdColLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "indvCdCol",
            page: page,
            size: size,
            keyword: data.colId,
            keywordName: data.colNm,
            param1: data.tbId,
        });
    },

    getLblLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "lbl",
            page: page,
            size: size,
            keyword: data.lblId,
            keywordName: data.lblNm,
        });
    },

    getComnCdMstrList: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "comnCdMstr",
            page: page,
            size: size,
            keyword: data.comnCd,
            keywordName: data.comnCdNm,
        });
    },

    getDcltLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "dclt",
            page: page,
            size: size,
            keyword: data.dcltTin,
            keywordName: data.dcltNm,
        });
    },

    getCoUsrtLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "coUsr",
            page: page,
            size: size,
            keyword: data.usrId,
            keywordName: data.usrNm,
        });
    },

    getOrgUsrtLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "orgUsr",
            page: page,
            size: size,
            keyword: data.usrId,
            keywordName: data.usrNm,
        });
    },

    getCoBucnLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "coBucn",
            page: page,
            size: size,
            keyword: data.bucnTin,
            keywordName: data.bucnNm,
            param1: data.coTin,
        });
    },
    getOrgzLst: (data: any) => {
        return comnUtils.getCode({
            area: "orgz",
            keyword: data.cstmOrgzId,
            keywordName: data.cstmOrgzNm,
            langCd: data.langCd,
            param1: data.cstmOrgzTpCd,
            param2: data.uprOrgzSrchYn,
        });
    },
    getOrgzUsrRgsrLst: (data: any) => {
        return comnUtils.getCode({
            area: "orgzUsrRgsr",
            keyword: data.cstmOrgzId,
            keywordName: data.cstmOrgzNm,
            langCd: data.langCd,
            param1: data.cstmOrgzTpCd,
            param2: data.uprOrgzSrchYn,
        });
    },
    getOrgzSubLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "orgzSub",
            page: page,
            size: size,
            keyword: data.cstmOrgzCd,
            keywordName: data.cstmOrgzNm,
            langCd: data.langCd,
            param1: data.cstmOrgzTpCd,
        });
    },
    getHldyLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "hldy",
            page: page,
            size: size,
            keyword: data.hldyId,
            keywordName: data.hldyNm,
            param1: data.ctraYy,
            param2: data.hldyTpCd,
        });
    },
    getCstmOrgzCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "cstmOrgzCd",
            page: page,
            size: size,
            keyword: data.cstmOrgzCd,
            keywordName: data.cstmOrgzNm,
            param1: data.cstmOrgzTpCd,
        });
    },

    getComnCdExcelLst: (data: any) => {
        return api.get(`/api/v1/ptli/intptl/comnppup/comn-cd/excel`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getPtlHsCdLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "hsCdPopupPtl",
            page: page,
            size: size,
            keyword: data.hsCd,
            keywordName: data.hsDesc,
            param1: data.hsDgt,
        });
    },

    getCsldrTinLst: (data: any, page: number, size: number) => {
        return comnUtils.getCode({
            area: "csldrTin",
            page: page,
            size: size,
            keyword: data.srchCsldrTin,
            keywordName: data.srchCsldrNm,
            param1: data.srchCsldrAddr,
        });
    },

    getRoleCdLst: (data: any, page: number, size: number) => {

        return comnUtils.getCode({
            area: "roleCd",
            page: page,
            size: size,
            keyword: data.roleId,
            keywordName: data.roleNm,
        });
    },
};

export const SCHEMA_GRID_COMN_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_COMN_CD", binding: "comnCd", width: "30%" }] },
        { cells: [{ header: "L_CD_VLD_VAL", binding: "cdVldVal", width: "30%" }] },
        { cells: [{ header: "L_CD_VLD_VAL_NM", binding: "cdVldValNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "comnCd" }] },
        { cells: [{ binding: "cdVldVal" }] },
        { cells: [{ binding: "cdVldValNm", align: "left" }] },
    ],
};

export const SCHEMA_GRID_CNTY_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CNTY_CD", binding: "cntyCd", width: "40%" }] },
        { cells: [{ header: "L_CNTY_NM", binding: "cntyNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "cntyCd" }],
        },
        {
            cells: [{ binding: "cntyNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_DGT3_CNTY_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CNTY_CD", binding: "dgt3CntyCd", width: "40%" }] },
        { cells: [{ header: "L_CNTY_NM", binding: "cntyNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "dgt3CntyCd" }],
        },
        {
            cells: [{ binding: "cntyNm", align: "left" }],
        },
    ],
};

export const SG_DGT3_NUM_CNTY_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CNTY_CD", binding: "dgt3NumCntyCd", width: "40%" }] },
        { cells: [{ header: "L_CNTY_NM", binding: "cntyNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "dgt3NumCntyCd" }],
        },
        {
            cells: [{ binding: "cntyNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_CITY_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_REGN_CD", binding: "regnCd", width: "20%" }] },
        { cells: [{ header: "L_REGN_NM", binding: "regnNm", width: "*" }] },
        { cells: [{ header: "L_REGN_TP_CD", binding: "regnTpCdNm", width: "20%" }] },
        { cells: [{ header: "L_CNTY_CD", binding: "cntyCd", width: "20%" }] },
    ],
    body: [
        { cells: [{ binding: "regnCd" }] },
        { cells: [{ binding: "regnNm", align: "left" }] },
        { cells: [{ binding: "regnTpCdNm" }] },
        { cells: [{ binding: "cntyCd" }] },
    ],
};

export const SCHEMA_GRID_PORT_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_PORT_CD", binding: "regnCd", width: "30%" }] },
        { cells: [{ header: "L_REGN_NM", binding: "regnNm", width: "*" }] },
        { cells: [{ header: "L_CNTY_CD", binding: "cntyCd", width: "30%" }] },
    ],
    body: [
        {
            cells: [{ binding: "regnCd" }],
        },
        {
            cells: [{ binding: "regnNm", align: "left" }],
        },
        {
            cells: [{ binding: "cntyCd" }],
        },
    ],
};

export const SCHEMA_GRID_AIRPT_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_AIRPT_CD", binding: "regnCd", width: "30%" }] },
        { cells: [{ header: "L_REGN_NM", binding: "regnNm", width: "*" }] },
        { cells: [{ header: "L_CNTY_CD", binding: "cntyCd", width: "30%" }] },
    ],
    body: [
        {
            cells: [{ binding: "regnCd" }],
        },
        {
            cells: [{ binding: "regnNm", align: "left" }],
        },
        {
            cells: [{ binding: "cntyCd" }],
        },
    ],
};

export const SCHEMA_GRID_PORT_AIRPT_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_PORT_AIRPT_CD", binding: "regnCd", width: "20%" }] },
        { cells: [{ header: "L_REGN_NM", binding: "regnNm", width: "*" }] },
        { cells: [{ header: "L_CNTY_CD", binding: "cntyCd", width: "20%" }] },
        { cells: [{ header: "L_PORT_AIRPT_TP_CD", binding: "portAirptTpCd", width: "30%" }] },
    ],
    body: [
        {
            cells: [{ binding: "regnCd" }],
        },
        {
            cells: [{ binding: "regnNm", align: "left" }],
        },
        {
            cells: [{ binding: "cntyCd" }],
        },
        {
            cells: [{ binding: "portAirptTpCd" }],
        },
    ],
};

export const SCHEMA_GRID_CURR_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CURR_CD", binding: "currCd", width: "40%" }] },
        { cells: [{ header: "L_CURR_NM", binding: "currNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "currCd" }],
        },
        {
            cells: [{ binding: "currNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_BNK_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CD_VLD_VAL", binding: "cdVldVal", width: "40%" }] },
        { cells: [{ header: "L_CD_VLD_VAL_NM", binding: "cdVldValNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "cdVldVal" }],
        },
        {
            cells: [{ binding: "cdVldValNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_CO_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "coTin", width: "40%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        { cells: [{ header: "L_CO_ADDR", binding: "coAddr", width: "*" }], show: false },
        { cells: [{ header: "L_CO_STAT", binding: "coStatCdNm", width: "10%" }], show: false },
    ],
    body: [
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coNm", align: "left" }],
        },
        {
            cells: [{ binding: "coAddr", align: "left" }],
        },
        {
            cells: [{ binding: "coStatCdNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_PRCSS_STAT_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_PRCSS_STAT_CD", binding: "item", width: "40%" }] },
        { cells: [{ header: "L_PRCSS_STAT", binding: "itemNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "item" }],
        },
        {
            cells: [{ binding: "itemNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_ORG_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_ORG_CD", binding: "orgCd", width: "40%" }] },
        { cells: [{ header: "L_ORG_NM", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_ORG_ADDR", binding: "orgAddr", width: "*" }], show: false },
        { cells: [{ header: "L_RPRS_TLPN_NO", binding: "rprsTelno", width: "20%" }], show: false },
    ],
    body: [
        {
            cells: [{ binding: "orgCd" }],
        },
        {
            cells: [{ binding: "orgNm", align: "left" }],
        },
        {
            cells: [{ binding: "orgAddr", align: "left" }],
        },
        {
            cells: [{ binding: "rprsTelno" }],
        },
    ],
};

export const SCHEMA_GRID_WRHS_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_WRHS_CD", binding: "coDclaCd", width: "40%" }] },
        { cells: [{ header: "L_WRHS_NM", binding: "wrhsNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "coDclaCd" }],
        },
        {
            cells: [{ binding: "wrhsNm", align: "left" }],
        },
    ],
};
export const SCHEMA_GRID_TRMNL_OPTR_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_TRMNL_OPTR_CD", binding: "trmnlOptrCd", width: "40%" }] },
        { cells: [{ header: "L_TRMNL_OPTR_NM", binding: "trmnlOptrNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "trmnlOptrCd" }],
        },
        {
            cells: [{ binding: "trmnlOptrNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_CARR_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CARR_CD", binding: "coDclaCd", width: "40%" }] },
        { cells: [{ header: "L_CARR_NM", binding: "carrNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "coDclaCd" }],
        },
        {
            cells: [{ binding: "carrNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_CO_DCLA_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out" },
    head: [
        { cells: [{ header: "L_CO_CD", binding: "coCd", width: "10%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
        // { cells: [{ header: "L_CO_CD_NM", binding: "coNm", width: "20%" }] },
        // { cells: [{ header: "L_CO_NM", binding: "companyNm", width: "*" }] },
        { cells: [{ header: "L_TIN", binding: "coTin", width: "15%" }] },
        { cells: [{ header: "L_CO_TP", binding: "coTpNm", width: "10%" }] },
        { cells: [{ header: "L_RSK_CAG_YN", binding: "rskCagYn", width: "10%" }] },
        { cells: [{ header: "L_SPCDL_WRHS_YN", binding: "spcdlWrhsYn", width: "10%" }] },
    ],
    body: [
        {
            cells: [{ binding: "coCd" }],
        },
        {
            cells: [{ binding: "coNm", align: "left" }],
        },
        // {
        //     cells: [{ binding: "companyNm", align: "left" }],
        // },
        {
            cells: [{ binding: "coTin" }],
        },
        {
            cells: [{ binding: "coTpNm" }],
        },
        {
            cells: [{ binding: "rskCagYn" }],
        },
        {
            cells: [{ binding: "spcdlWrhsYn" }],
        },
    ],
};

export const SCHEMA_GRID_ORG_DEPT_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_DEPT_CD", binding: "deptCd", width: "20%" }] },
        { cells: [{ header: "L_DEPT_NM", binding: "deptNm", width: "30%" }] },
        { cells: [{ header: "L_ORG_CD", binding: "orgCd", width: "20%" }] },
        { cells: [{ header: "L_ORG_NM", binding: "orgNm", width: "30%" }] },
        { cells: [{ header: "L_DEPT_DESC", binding: "deptDesc", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "deptCd" }] },
        { cells: [{ binding: "deptNm", align: "left" }] },
        { cells: [{ binding: "orgCd" }] },
        { cells: [{ binding: "orgNm", align: "left" }] },
        { cells: [{ binding: "deptDesc", align: "left" }] },
    ],
};

export const SCHEMA_GRID_CSTM_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CSTM_CD", binding: "cstmOfceCd", width: "30%" }] },
        { cells: [{ header: "L_CSTM_NM", binding: "cstmNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_TP_CD", binding: "cstmTpCd", width: "5%" }], show: false },
        { cells: [{ header: "L_CSTM_TP_NM", binding: "coTpCdNm", width: "30%" }] },
        { cells: [{ header: "L_CSTM_ADDR", binding: "cstmAddr", width: "30%" }], show: false },
    ],
    body: [
        {
            cells: [{ binding: "cstmOfceCd" }],
        },
        {
            cells: [{ binding: "cstmNm", align: "left" }],
        },
        {
            cells: [{ binding: "cstmTpCd" }],
        },
        {
            cells: [{ binding: "cstmTpCdNm", align: "left" }],
        },
        {
            cells: [{ binding: "cstmAddr", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_CSTM_OFCR_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_USR_DMN_ID", binding: "usrDmnId", width: "40%" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE_CD", binding: "cstmOfceCd", width: "20%" }] },
    ],
    body: [
        {
            cells: [{ binding: "usrDmnId" }],
        },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "cstmOfceCd" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_BODY_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_BODY_TP_CD", binding: "vhclBodyTpCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_BODY_TP_NM", binding: "vhclBodyTpNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclBodyTpCd" }],
        },
        {
            cells: [{ binding: "vhclBodyTpNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_CTGR_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_CTGR_CD", binding: "vhclCtgrCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_CTGR_NM", binding: "vhclCtgrNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclCtgrCd" }],
        },
        {
            cells: [{ binding: "vhclCtgrNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_CLR_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_CLR_CD", binding: "vhclClrCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_CLR_NM", binding: "vhclClrNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclClrCd" }],
        },
        {
            cells: [{ binding: "vhclClrNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_FL_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_FL_TP_CD", binding: "vhclFlTpCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_FL_NM", binding: "vhclFlNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclFlTpCd" }],
        },
        {
            cells: [{ binding: "vhclFlNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_IMP_CNTY_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_CNTY_CD", binding: "vhclCntyCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_CNTY_NM", binding: "vhclCntyNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclCntyCd" }],
        },
        {
            cells: [{ binding: "vhclCntyNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_INSR_TP_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_INSR_TP_CD", binding: "vhclInsrTpCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_INSR_TP_NM", binding: "vhclInsrTpNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclInsrTpCd" }],
        },
        {
            cells: [{ binding: "vhclInsrTpNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_MKER_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_MNFC_CD", binding: "vhclMkerCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_MNFC_NM", binding: "vhclMkerNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclMkerCd" }],
        },
        {
            cells: [{ binding: "vhclMkerNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_MDL_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_MDL_CD", binding: "vhclMdlCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_MDL_NM", binding: "vhclMdlNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclMdlCd" }],
        },
        {
            cells: [{ binding: "vhclMdlNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_MDL_NO_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_MDL_NO_CD", binding: "vhclMdlNoCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_MDL_NO_NM", binding: "vhclMdlNoNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclMdlNoCd" }],
        },
        {
            cells: [{ binding: "vhclMdlNoNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_HLPN_CTGR_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_HLPN_CTGR_CD", binding: "vhclHlpnCtgrCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_HLPN_CTGR_NM", binding: "vhclHlpnCtgrNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclHlpnCtgrCd" }],
        },
        {
            cells: [{ binding: "vhclHlpnCtgrNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_PRPL_TP_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_PRPL_TP_CD", binding: "vhclPrplTpCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_PRPL_TP_NM", binding: "vhclPrplTpNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclPrplTpCd" }],
        },
        {
            cells: [{ binding: "vhclPrplTpNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_TRMSSN_TP_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_TRMSSN_TP_CD", binding: "vhclTrmssnTpCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_TRMSSN_TP_NM", binding: "vhclTrmssnTpNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclTrmssnTpCd" }],
        },
        {
            cells: [{ binding: "vhclTrmssnTpNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_VHCL_USE_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_VHCL_USE_CD", binding: "vhclUseCd", width: "40%" }] },
        { cells: [{ header: "L_VHCL_USE_NM", binding: "vhclUseNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "vhclUseCd" }],
        },
        {
            cells: [{ binding: "vhclUseNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_TIN_NO: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_TIN_NO", binding: "tinNo", width: "40%" }] },
        { cells: [{ header: "L_CO_NM", binding: "coNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "tinNo" }],
        },
        {
            cells: [{ binding: "coNm", align: "left" }],
        },
    ],
};

export const SCHEMA_GRID_UCR_NO: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_UCR_NO", binding: "ucrNo", width: "30%" }] },
        { cells: [{ header: "L_UCR_REGM_CD_NM", binding: "ucrRegmCdNm", width: "15%" }] },
        { cells: [{ header: "L_DCLT", binding: "dcltNm", width: "15%" }], show: false },
        { cells: [{ header: "L_EXPPN_TIN", binding: "exppnTin", width: "10%" }] },
        { cells: [{ header: "L_EXPPN", binding: "exppnNm", width: "*" }] },
        { cells: [{ header: "L_IMPPN_TIN", binding: "imppnTin", width: "10%" }] },
        { cells: [{ header: "L_IMPPN", binding: "imppnNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "ucrNo" }] },
        { cells: [{ binding: "ucrRegmCdNm" }] },
        { cells: [{ binding: "dcltNm" }] },
        { cells: [{ binding: "exppnTin" }] },
        { cells: [{ binding: "exppnNm" }] },
        { cells: [{ binding: "imppnTin" }] },
        { cells: [{ binding: "imppnNm" }] },
    ],
};

//Schema of APC Code Search Form !==APC 관리 목록 검색 폼 스키마 ==!
export const SF_APC_MGMT_SRCH: TFormSchema = {
    id: "form_ApcSrch",
    schema: {
        apcCd: { type: "text", label: "L_APC", controlSize: 2, maxLength: 3 },
        apcDesc: { type: "text", label: "L_APC_DESC", controlSize: 6 },
        useYn: {
            type: "select",
            label: "L_APPD_YN",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            controlSize: 2,
        },
    },
};

//Schema of EPC Code Search Form !==EPC 관리 목록 검색 폼 스키마 ==!
export const SF_EPC_MGMT_SRCH: TFormSchema = {
    id: "form_EpcSrch",
    schema: {
        epcCd: { type: "text", label: "L_EPC", controlSize: 2, mask: [/\d/, /\d/, /\d/, /\d/] },
        epcDesc: { type: "text", label: "L_EPC_DESC", controlSize: 6 },
        useYn: {
            type: "select",
            label: "L_APPD_YN",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            controlSize: 2,
        },
    },
};

export const SCHEMA_FORM_COMN_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        comnCd: { type: "text", label: "L_COMN_CD" },
        cdVldVal: { type: "text", label: "L_CD_VLD_VAL", letterCase: "upper" },
        cdVldValNm: { type: "text", label: "L_CD_VLD_VAL_NM" },
        langCd: {
            type: "select",
            label: "L_LANG_CD",
            required: true,
            options: [
                { label: "L_SW", value: "SW" },
                { label: "L_EN", value: "EN" },
                { label: "L_KO", value: "KO" },
            ],
        },
    },
};

export const SCHEMA_FORM_CNTY_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        cntyCd: { type: "text", label: "L_CNTY_CD", letterCase: "upper" },
        cntyNm: { type: "text", label: "L_CNTY_NM" },
    },
};

export const SCHEMA_FORM_DGT3_CNTY_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        dgt3CntyCd: { type: "text", label: "L_CNTY_CD", letterCase: "upper" },
        cntyNm: { type: "text", label: "L_CNTY_NM" },
    },
};

export const SF_DGT3_NUM_CNTY_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        dgt3NumCntyCd: { type: "text", label: "L_CNTY_CD", letterCase: "upper" },
        cntyNm: { type: "text", label: "L_CNTY_NM" },
    },
};

export const SCHEMA_FORM_CITY_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        cntyCd: { type: "code", label: "L_CNTY_CD", area: "cntyCd", popupSize: "sm" },
        cntyCdArr: { type: "checkbox", label: "L_CNTY_CD", area: "cntyCd" },
        regnTpCd: {
            type: "select",
            label: "L_REGN_TP_CD",
            options: [
                { label: "IATA", value: "01" },
                { label: "UN/LOCODE", value: "02" },
            ],
        },
        regnNm: { type: "text", label: "L_REGN_NM" },
        regnCd: {
            type: "text",
            label: "L_REGN_CD",
            letterCase: "upper",
        },
    },
};

export const SCHEMA_FORM_PORT_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        cntyCd: { type: "code", label: "L_CNTY_CD", area: "cntyCd" },
        cntyCdArr: { type: "checkbox", label: "L_CNTY_CD", area: "cntyCd" },
        regnNm: { type: "text", label: "L_REGN_NM" },
        regnCd: { type: "text", label: "L_PORT_CD", letterCase: "upper" },
    },
};

export const SCHEMA_FORM_AIRPT_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        cntyCd: { type: "code", label: "L_CNTY_CD", area: "cntyCd" },
        cntyCdArr: { type: "checkbox", label: "L_CNTY_CD", area: "cntyCd" },
        regnNm: { type: "text", label: "L_REGN_NM" },
        regnCd: { type: "text", label: "L_AIRPT_CD", letterCase: "upper" },
    },
};

export const SCHEMA_FORM_PORT_AIRPT_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        portAirptTpCd: {
            type: "select",
            label: "L_PORT_AIRPT_TP",
            options: [
                { label: "L_PORT", value: "PORT" },
                { label: "L_AIRPT", value: "AIRPT" },
                { label: "UN/LOCODE", value: "UNLOCODE" },
            ],
        },
        cntyCd: { type: "code", label: "L_CNTY_CD", area: "cntyCd" },
        cntyCdArr: { type: "checkbox", label: "L_CNTY_CD", area: "cntyCd" },
        regnNm: { type: "text", label: "L_REGN_NM" },
        regnCd: { type: "text", label: "L_PORT_AIRPT_CD", letterCase: "upper" },
    },
};

export const SCHEMA_FORM_CURR_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        currCd: { type: "text", label: "L_CURR_CD", letterCase: "upper" },
        currNm: { type: "text", label: "L_CURR_NM" },
    },
};

export const SCHEMA_FORM_BNK_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        cdVldVal: { type: "text", label: "L_BNK_CD", letterCase: "upper" },
        cdVldValNm: { type: "text", label: "L_BNK_NM" },
    },
};

export const SCHEMA_FORM_CO_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        coTin: { type: "text", label: "L_TIN" },
        coNm: { type: "text", label: "L_CO_NM" },
        coTpCd: {
            type: "select",
            label: "L_CO_PT",
            required: true,
            options: [
                { label: "L_CO", value: "C" },
                { label: "L_PSN", value: "P" },
            ],
        },
    },
};

export const SCHEMA_FORM_PRCSS_STAT_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        item: { type: "text", label: "L_PRCSS_STAT_CD", letterCase: "upper" },
        itemNm: { type: "text", label: "L_PRCSS_STAT" },
    },
};

// LPCO Issue Yes or Not   !== LPCO  발급 여부 ==!
const lpcoYn = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
];

export const SCHEMA_FORM_ORG_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        orgCd: { type: "text", label: "L_ORG_CD", letterCase: "upper" },
        orgNm: { type: "text", label: "L_ORG_NM" },
        lpcoIssuYn: { type: "select", label: "L_LPCO_ISSU_YN", options: lpcoYn },
    },
};

export const SCHEMA_FORM_WRHS_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        coDclaCd: { type: "text", label: "L_WRHS_CD", letterCase: "upper" },
        wrhsNm: { type: "text", label: "L_WRHS_NM" },
        wrhsOprtTpCd: { type: "text" },
        cstmOfceCd: { type: "text" },
    },
};

export const SCHEMA_FORM_TRMNL_OPTR_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        trmnlOptrCd: { type: "text", label: "L_TRMNL_OPTR_CD", letterCase: "upper" },
        trmnlOptrNm: { type: "text", label: "L_TRMNL_OPTR_NM" },
    },
};

export const SCHEMA_FORM_CARR_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        coDclaCd: { type: "text", label: "L_CARR_CD", letterCase: "upper" },
        carrNm: { type: "text", label: "L_CARR_NM" },
    },
};

export const SCHEMA_FORM_CO_DCLA_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        coCd: { type: "text", label: "L_CO_CD" },
        coTin: { type: "text", label: "L_TIN" },
        coNm: { type: "text", label: "L_CO_CD_NM" },
        coTpCd: {
            all: true,
            type: "checkbox",
            label: "L_CO_TP",
            area: "comnCd",
            comnCd: "COM0011",
        },
        spcdlWrhsYn: { type: "text", label: "L_SPCDL_WRHS_YN" },
    },
};

export const SCHEMA_FORM_ORG_DEPT_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        deptCd: { type: "text", label: "L_DEPT_CD", letterCase: "upper" },
        deptNm: { type: "text", label: "L_DEPT_NM" },
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", letterCase: "upper" },
        orgNm: { type: "text", label: "L_ORG_NM" },
    },
};

export const SCHEMA_FORM_CSTM_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        cstmOfceCd: { type: "text", label: "L_CSTM_CD", letterCase: "upper" },
        cstmNm: { type: "text", label: "L_CSTM_NM" },
        cstmTpCd: {
            type: "checkbox",
            label: "L_CSTM_TP",
            area: "comnCd",
            comnCd: "COM0016",
            excludes: ["0", "SA", "SL"],
        },
        dclrYn: { type: "text" },
    },
};
export const SCHEMA_FORM_CSTM_OFCR_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        usrDmnId: { type: "text", label: "L_USR_DMN_ID", letterCase: "upper" },
        usrNm: { type: "text", label: "L_USR_NM" },
        cstmOfceCd: { type: "text", label: "L_CSTM_OFCE_CD", letterCase: "upper" },
        usrStatCd: { type: "text" },
        roleId: { type: "text" },
    },
};

export const SCHEMA_FORM_VHCL_BODY_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclBodyTpCd: { type: "text", label: "L_VHCL_BODY_TP_CD" },
        vhclBodyTpNm: { type: "text", label: "L_VHCL_BODY_TP_NM" },
    },
};

export const SCHEMA_FORM_VHCL_CTGR_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclCtgrCd: { type: "text", label: "L_VHCL_CTGR_CD" },
        vhclCtgrNm: { type: "text", label: "L_VHCL_CTGR_NM" },
    },
};

export const SCHEMA_FORM_VHCL_CLR_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclClrCd: { type: "text", label: "L_VHCL_CLR_CD" },
        vhclClrNm: { type: "text", label: "L_VHCL_CLR_NM" },
    },
};

export const SCHEMA_FORM_VHCL_FL_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclFlTpCd: { type: "text", label: "L_VHCL_FL_TP_CD" },
        vhclFlNm: { type: "text", label: "L_VHCL_FL_NM" },
    },
};

export const SCHEMA_FORM_VHCL_IMP_CNTY_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclCntyCd: { type: "text", label: "L_VHCL_CNTY_CD" },
        vhclCntyNm: { type: "text", label: "L_VHCL_CNTY_NM" },
    },
};

export const SCHEMA_FORM_VHCL_INSR_TP_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclInsrTpCd: { type: "text", label: "L_VHCL_INSR_TP_CD" },
        vhclInsrTpNm: { type: "text", label: "L_VHCL_INSR_TP_NM" },
    },
};

export const SCHEMA_FORM_VHCL_MKER_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclMkerCd: { type: "text", label: "L_VHCL_MNFC_CD" },
        vhclMkerNm: { type: "text", label: "L_VHCL_MNFC_NM" },
    },
};

export const SCHEMA_FORM_VHCL_MDL_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclMdlCd: { type: "text", label: "L_VHCL_MDL_CD" },
        vhclMdlNm: { type: "text", label: "L_VHCL_MDL_NM" },
    },
};

export const SCHEMA_FORM_VHCL_MDL_NO_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclMdlNoCd: { type: "text", label: "L_VHCL_MDL_NO_CD" },
        vhclMdlNoNm: { type: "text", label: "L_VHCL_MDL_NO_NM" },
    },
};

export const SCHEMA_FORM_VHCL_HLPN_CTGR_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclHlpnCtgrCd: { type: "text", label: "L_VHCL_HLPN_CTGR_CD" },
        vhclHlpnCtgrNm: { type: "text", label: "L_VHCL_HLPN_CTGR_NM" },
    },
};

export const SCHEMA_FORM_VHCL_PRPL_TP_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclPrplTpCd: { type: "text", label: "L_VHCL_PRPL_TP_CD" },
        vhclPrplTpNm: { type: "text", label: "L_VHCL_PRPL_TP_NM" },
    },
};

export const SCHEMA_FORM_VHCL_TRMSSN_TP_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclTrmssnTpCd: { type: "text", label: "L_VHCL_TRMSSN_TP_CD" },
        vhclTrmssnTpNm: { type: "text", label: "L_VHCL_TRMSSN_TP_NM" },
    },
};

export const SCHEMA_FORM_VHCL_USE_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        vhclUseCd: { type: "text", label: "L_VHCL_USE_CD" },
        vhclUseNm: { type: "text", label: "L_VHCL_USE_NM" },
    },
};
export const SCHEMA_FORM_TIN_NO_SRCH: TFormSchema = {
    id: "form",
    schema: {
        tinNo: { type: "text", label: "L_TIN_NO" },
        coNm: { type: "text", label: "L_CO_NM" },
    },
};

export const SCHEMA_FORM_UCR_NO_SRCH: TFormSchema = {
    id: "form",
    schema: {
        ucrNo: { type: "text", label: "L_UCR_NO", letterCase: "upper" },
        ucrRegmCd: {
            type: "select",
            label: "L_UCR_REGM_CD",
            area: "comnCd",
            comnCd: "PTL0013",
        },
        exppnTin: {
            type: "code",
            label: "L_EXPPN_TIN",
            area: "tinNo",
            popupSize: "sm",
        },
        exppnNm: {
            type: "text",
            label: "L_EXPPN",
        },
        imppnTin: {
            type: "code",
            label: "L_IMPPN_TIN",
            area: "tinNo",
            popupSize: "sm",
        },
        imppnNm: {
            type: "text",
            label: "L_IMPPN",
        },
    },
};

export const SCHEMA_CO_CD_DTL: TFormSchema = {
    id: "form",
    schema: {
        coTin: { type: "text", label: "L_CO_TIN" },
        coTpCdNm: { type: "text", label: "L_CO_TP_CD_NM" },
        coNm: { type: "text", label: "L_CO_NM" },
        coAddr: { type: "text", label: "L_CO_ADDR" },
        rprsTelno: { type: "text", label: "L_RPRS_TELNO" },
        rRprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO" },
        rprsEml: { type: "text", label: "L_RPRS_EML" },
        prcssStatCdNm: { type: "text", label: "L_PRCSS_STAT_CD_NM" },
    },
};

export const SF_HS_CD_SRCH: TFormSchema = {
    id: "form_HsCdSrch",
    schema: {
        hsCd: {
            type: "text",
            label: "L_HS",
            area: "hsCd",
            controlSize: 4,
            rightButton: { icon: "search" },
            placeholder: "0000.00.00.0000",
            mask: [/\d/, /\d/, /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/],
        },
        hsDesc: { type: "text", label: "L_HS_DESC", area: "hsDesc", controlSize: 4 },
        hsDgt: {
            type: "radio",
            area: "comnCd",
            comnCd: "CLR0170",
            excludes: ["0"],
            label: "L_HS_DGT",
            defaultValue: "12",
            controlSize: 10,
        },
    },
};

export const SG_HS_CD_LST: TGridSchema = {
    id: "grid",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: "40%" }] },
        { cells: [{ header: "L_VERSION", binding: "histSrno", width: "15%" }], show: false },
        { cells: [{ header: "L_HS_DESC", binding: "hsDesc", width: "*" }] },
        { cells: [{ header: "L_QTY", binding: "itmQtyUtCd", width: "*" }], show: false },
        { cells: [{ header: "L_APPD_YN", binding: "useYn", width: "10%" }], show: false },
    ],
    body: [
        {
            cells: [{ binding: "hsCd" }],
        },
        {
            cells: [{ binding: "histSrno" }],
        },
        {
            cells: [{ binding: "hsDesc", align: "left" }],
        },
        {
            cells: [{ binding: "itmQtyUtCd" }],
        },
        {
            cells: [{ binding: "useYn" }],
        },
    ],
};

export const SF_POST_CD_SRCH: TFormSchema = {
    id: "form_PostCd",
    schema: {
        postTpCd: {
            type: "select",
            label: "L_POST_TP_CD",
            required: true,
            options: [
                { label: "L_REGN", value: "Region" },
                { label: "L_DSTR", value: "District" },
                { label: "L_WARD", value: "Ward" },
            ],
        },
        postCd: {
            type: "number",
            label: "L_POST_CD",
            area: "postCd",
            controlSize: 4,
            thousandSeparator: false,
        },
        postNm: {
            type: "text",
            label: "L_POST_NM",
            area: "postNm",
        },
    },
};

export const SG_POST_CD_LST: TGridSchema = {
    id: "grid_PostCd",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_REGN_POST_CD", binding: "regnPostCd", width: "15%" }] },
        { cells: [{ header: "L_REGN_POST_NM", binding: "regnPostNm", width: "*" }] },
        { cells: [{ header: "L_DSTR_POST_CD", binding: "dstrPostCd", width: "15%" }] },
        { cells: [{ header: "L_DSTR_POST_NM", binding: "dstrPostNm", width: "*" }] },
        { cells: [{ header: "L_WARD_POST_CD", binding: "wardPostCd", width: "15%" }] },
        { cells: [{ header: "L_WARD_POST_NM", binding: "wardPostNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "regnPostCd" }],
        },
        {
            cells: [{ binding: "regnPostNm", align: "left" }],
        },
        {
            cells: [{ binding: "dstrPostCd" }],
        },
        {
            cells: [{ binding: "dstrPostNm", align: "left" }],
        },
        {
            cells: [{ binding: "wardPostCd" }],
        },
        {
            cells: [{ binding: "wardPostNm", align: "left" }],
        },
    ],
};

export const SF_TB_SRCH: TFormSchema = {
    id: "form_tbSrch",
    schema: {
        tbId: { type: "text", label: "L_TB_ID", letterCase: "upper" },
        tbNm: { type: "text", label: "L_TB_NM" },
    },
};

//Schema of EPC Code List Grid !==EPC 관리 목록 그리드 스키마 ==!
export const SG_EPC_MGMT_LST: TGridSchema = {
    id: "grid",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        exportExcel: false,
        importExcel: false,
        //height: 200,
    },
    head: [
        { cells: [{ header: "L_EPC", binding: "epcCd", width: "40%" }] },
        { cells: [{ header: "L_EPC_DESC", binding: "epcDesc", width: "*" }] },
    ],
    body: [{ cells: [{ binding: "epcCd", area: "epcCd" }] }, { cells: [{ binding: "epcDesc" }] }],
};

export const apcTpCd = [
    { label: "General", value: "G" },
    { label: "Exemtion", value: "E" },
    { label: "Quata", value: "Q" },
    { label: "Post-Entry", value: "P" },
];

//Schema of APC Code List Grid !==APC 관리 목록 그리드 스키마 ==!
export const SG_APC_MGMT_LST: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, checkbox: false, index: true },
    head: [
        { cells: [{ header: "L_APC", binding: "apcCd", width: "40%" }] },
        { cells: [{ header: "L_APC_DESC", binding: "apcDesc", width: "*" }] },
        { cells: [{ header: "L_APC_TP", binding: "apcTpCd", width: "20%" }], show: false },
    ],
    body: [
        { cells: [{ binding: "apcCd" }] },
        { cells: [{ binding: "apcDesc", align: "left" }] },
        { cells: [{ binding: "apcTpCd", options: apcTpCd, type: "radio" }] },
    ],
};

export const SG_TB_LIST: TGridSchema = {
    id: "grid_tbList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        // { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "*" }] },
        { cells: [{ header: "L_TB_ID", binding: "tbId", width: "*" }] },
        { cells: [{ header: "L_TB_NM", binding: "tbNm", width: "*" }] },
    ],
    body: [
        // { cells: [{ binding: "bsopClsfCd", edit: false }] },
        { cells: [{ binding: "tbId", edit: false }] },
        { cells: [{ binding: "tbNm", edit: false, align: "left" }] },
    ],
};

export const SF_COL_SRCH: TFormSchema = {
    id: "form_colSrch",
    schema: {
        tbId: { type: "text", label: "L_TB_ID", readOnly: true },
        colId: { type: "text", label: "L_COL_ID", letterCase: "upper" },
        colNm: { type: "text", label: "L_COL_NM" },
    },
};

export const SG_COL_LIST: TGridSchema = {
    id: "grid_colList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_TB_ID", binding: "tbId", width: "*" }] },
        { cells: [{ header: "L_COL_ID", binding: "colId", width: "*" }] },
        { cells: [{ header: "L_COL_NM", binding: "colNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "tbId", edit: false, align: "left" }] },
        { cells: [{ binding: "colId", edit: false, align: "left" }] },
        { cells: [{ binding: "colNm", edit: false, align: "left" }] },
    ],
};

export const SF_LBL_SRCH: TFormSchema = {
    id: "form_colSrch",
    schema: {
        lblId: { type: "text", label: "L_LBL_ID" },
        lblNm: { type: "text", label: "L_LBL_NM" },
    },
};

export const SG_LBL_LIST: TGridSchema = {
    id: "grid_colList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_LBL_ID", binding: "lblId", width: "*" }] },
        { cells: [{ header: "L_LBL_NM", binding: "lblNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "lblId", edit: false }] },
        { cells: [{ binding: "lblNm", edit: false, align: "left" }] },
    ],
};

export const SF_COMN_CD_MSTR_SRCH: TFormSchema = {
    id: "form_comnCdMstrSrch",
    schema: {
        comnCd: { type: "text", label: "L_COMN_CD", letterCase: "upper" },
        comnCdNm: { type: "text", label: "L_COMN_CD_NM" },
    },
};

export const SG_COMN_CD_MSTR_LIST: TGridSchema = {
    id: "grid_comnCdMstrList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "*" }] },
        { cells: [{ header: "L_COMN_CD", binding: "comnCd", width: "*" }] },
        { cells: [{ header: "L_COMN_CD_NM", binding: "comnCdNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCd", edit: false }] },
        { cells: [{ binding: "comnCd", edit: false }] },
        { cells: [{ binding: "comnCdNm", edit: false, align: "left" }] },
    ],
};

export const SF_DCLT_SRCH: TFormSchema = {
    id: "form_dcltSrch",
    schema: {
        dcltTin: { type: "text", label: "L_DCLT_TIN" },
        dcltNm: { type: "text", label: "L_DCLT_NM" },
    },
};

export const SG_DCLT_LIST: TGridSchema = {
    id: "grid_dcltList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_DCLT_TIN", binding: "dcltTin", width: "40%" }] },
        { cells: [{ header: "L_DCLT_NM", binding: "dcltNm", width: "*" }] },
        { cells: [{ header: "L_DCLT_ADDR", binding: "dcltAddr", width: "*" }], show: false },
        { cells: [{ header: "L_DCLT_TELNO", binding: "dcltTelno", width: "15%" }], show: false },
        { cells: [{ header: "L_DCLT_FAX_NO", binding: "dcltFaxNo", width: "15%" }], show: false },
    ],
    body: [
        { cells: [{ binding: "dcltTin", edit: false }] },
        { cells: [{ binding: "dcltNm", edit: false, align: "left" }] },
        { cells: [{ binding: "dcltAddr", edit: false, align: "left" }] },
        { cells: [{ binding: "dcltTelno", edit: false, align: "left" }] },
        { cells: [{ binding: "dcltFaxNo", edit: false, align: "left" }] },
    ],
};

export const SF_CO_USR_SRCH: TFormSchema = {
    id: "form_coUsrSrch",
    schema: {
        usrId: { type: "text", label: "L_USR_ID" },
        usrNm: { type: "text", label: "L_USR_NM" },
    },
};

export const SG_CO_USR_LIST: TGridSchema = {
    id: "grid_coUsrList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "usrId", width: "40%" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_MOBL_NO", binding: "moblNo", width: "*" }], show: false },
        { cells: [{ header: "L_EML_ADDR", binding: "emlAddr", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "usrId", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        { cells: [{ binding: "moblNo", edit: false }] },
        { cells: [{ binding: "emlAddr", edit: false, align: "left" }] },
    ],
};

export const SF_ORG_USR_SRCH: TFormSchema = {
    id: "form_orgUsrSrch",
    schema: {
        usrId: { type: "text", label: "L_USR_ID" },
        usrNm: { type: "text", label: "L_USR_NM" },
    },
};

export const SG_ORG_USR_LIST: TGridSchema = {
    id: "grid_orgUsrList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "usrId", width: "40%" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_MOBL_NO", binding: "moblNo", width: "*" }], show: false },
        { cells: [{ header: "L_EML_ADDR", binding: "emlAddr", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "usrId", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        { cells: [{ binding: "moblNo", edit: false }] },
        { cells: [{ binding: "emlAddr", edit: false }] },
    ],
};

export const SF_CO_BUCN_SRCH: TFormSchema = {
    id: "form_coBucnSrch",
    schema: {
        bucnTin: { type: "text", label: "L_TIN" },
        bucnNm: { type: "text", label: "L_BUCN_NM" },
    },
};

export const SG_CO_BUCN_LIST: TGridSchema = {
    id: "grid_coBucnList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_TIN", binding: "bucnTin", width: "40%" }] },
        { cells: [{ header: "L_BUCN_NM", binding: "bucnNm", width: "*" }] },
        { cells: [{ header: "L_BUCN_ADDR", binding: "bucnAddr", width: "*" }], show: false },
        { cells: [{ header: "L_RPRS_TELNO", binding: "rprsTelno", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "bucnTin", edit: false }] },
        { cells: [{ binding: "bucnNm", edit: false, align: "left" }] },
        { cells: [{ binding: "bucnAddr", edit: false }] },
        { cells: [{ binding: "rprsTelno", edit: false }] },
    ],
};

export const SF_ORGZ_SRCH: TFormSchema = {
    id: "form_orgzSrch",
    schema: {
        cstmOrgzNm: { type: "text", label: "L_ORGZ_NM" },
        cstmOrgzTpCd: { type: "select", label: "L_ORGZ_TP", all: true, area: "comnCd", comnCd: "PTL0021" },
        langCd: { type: "text", label: "L_LANG_CD" },
        uprOrgzSrchYn: { type: "text", label: "L_UPR_ORGZ_SRCH_YN" },
    },
};

export const SF_ORGZ_INFO: TFormSchema = {
    id: "form_orgzInfo",
    schema: {
        uprCstmOrgzId: { type: "text", label: "L_UPR_CSTM_ORGZ_ID", required: true, labelSize: 5 },
        cstmOrgzTpCd: {
            type: "select",
            label: "L_ORGZ_TP",
            area: "comnCd",
            comnCd: "PTL0021",
            rows: 5,
            required: true,
            labelSize: 5,
        },
        cstmOrgzNm: { type: "text", label: "L_ORGZ_NM", labelSize: 5 },
    },
};

export const SF_ORGZ_SUB_SRCH: TFormSchema = {
    id: "form_orgzSubSrch",
    schema: {
        cstmOrgzNm: { type: "text", label: "L_ORGZ_NM" },
        cstmOrgzCd: { type: "text", label: "L_CSTM_ORGZ_ID", letterCase: "upper" },
        cstmOrgzTpCd: { type: "text", label: "L_CSTM_ORGZ_TP_CD" },
    },
};

export const SCHEMA_GRID_ORGZ_SUB_CD: TGridSchema = {
    id: "grid_orgzSubCd",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_CSTM_ORGZ_ID", binding: "cstmOrgzCd", width: "40%" }] },
        { cells: [{ header: "L_ORGZ_TP", binding: "cstmOrgzTpCd", width: "*" }] },
        { cells: [{ header: "L_ORGZ_NM", binding: "cstmOrgzNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "cstmOrgzCd" }],
        },
        {
            cells: [{ binding: "cstmOrgzTpCd", type: "code", area: "comnCd", comnCd: "PTL0021" }],
        },
        {
            cells: [{ binding: "cstmOrgzNm", align: "left" }],
        },
    ],
};

export const SF_HLDY_SRCH: TFormSchema = {
    id: "form_hldySrch",
    schema: {
        ctraYy: { type: "text", label: "L_CTRA_YY", maxLength: 4 },
        hldyTpCd: { type: "select", label: "L_HLDY_TP_CD", area: "comnCd", comnCd: "COM0057" },
    },
};

export const SG_HLDY_LIST: TGridSchema = {
    id: "grid_hldyList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CTRA_DT", binding: "ctraDt", width: "*" }] },
        { cells: [{ header: "L_HLDY_NM", binding: "hldyNm", width: "*" }] },
        { cells: [{ header: "L_HLDY_TP_CD", binding: "hldyTp", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "ctraDt", edit: false }] },
        { cells: [{ binding: "hldyNm", edit: false, align: "left" }] },
        { cells: [{ binding: "hldyTp", edit: false, align: "left" }] },
    ],
};

export const SF_CSTM_ORGZ_CD_SRCH: TFormSchema = {
    id: "form_cstmOrgzCdSrch",
    schema: {
        cstmOrgzCd: { type: "text", label: "L_CSTM_ORGZ_CD" },
        cstmOrgzTpCd: {
            type: "select",
            label: "L_CSTM_ORGZ_TP_CD",
            all: true,
            area: "comnCd",
            comnCd: "PTL0021",
            excludes: ["C"],
        },
        cstmOrgzNm: { type: "text", label: "L_CSTM_ORGZ_NM" },
    },
};

export const SG_CSTM_ORGZ_CD_LIST: TGridSchema = {
    id: "grid_cstmOrgzCdList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CSTM_ORGZ_CD", binding: "cstmOrgzCd", width: "20%" }] },
        { cells: [{ header: "L_CSTM_ORGZ_TP_NM", binding: "cstmOrgzTpNm", width: "20%" }] },
        { cells: [{ header: "L_CSTM_ORGZ_NM", binding: "cstmOrgzNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "cstmOrgzCd", edit: false }] },
        { cells: [{ binding: "cstmOrgzTpNm", edit: false, align: "left" }] },
        { cells: [{ binding: "cstmOrgzNm", edit: false, align: "left" }] },
    ],
};

export const SG_COMM_CD_EXCEL_FORM: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_COMN_CD", binding: "comnCd", width: "10%" }] },
        { cells: [{ header: "L_CD_VLD_VAL", binding: "cdVldVal", width: "15%" }] },
        { cells: [{ header: "L_CD_VLD_VAL_NM", binding: "cdVldValNm", width: "30%" }] },
    ],
    body: [
        { cells: [{ binding: "comnCd" }] },
        { cells: [{ binding: "cdVldVal" }] },
        { cells: [{ binding: "cdVldValNm", align: "left" }] },
    ],
};

export const SCHEMA_FORM_CSLDR_TIN_SRCH: TFormSchema = {
    id: "form",
    schema: {
        srchCsldrTin: { type: "text", label: "L_CSLDR_TIN" },
        srchCsldrNm: { type: "text", label: "L_CSLDR_NM" },
        srchCsldrAddr: { type: "text", label: "L_CSLDR_ADDR" },
    },
};

export const SCHEMA_GRID_DSLDR_TIN: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_CSLDR_TIN", binding: "csldrTin", width: "20%" }] },
        { cells: [{ header: "L_CSLDR_NM", binding: "csldrNm", width: "30%" }] },
        { cells: [{ header: "L_CSLDR_ADDR", binding: "csldrAddr", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "csldrTin" }] },
        { cells: [{ binding: "csldrNm", align: "left" }] },
        { cells: [{ binding: "csldrAddr", align: "left" }] },
    ],
};

export const SCHEMA_FORM_ROLE_CD_SRCH: TFormSchema = {
    id: "form",
    schema: {
        roleId: { type: "text", label: "L_ROLE_ID", letterCase: "upper" },
        roleNm: { type: "text", label: "L_ROLE_NM" },
    },
};

export const SCHEMA_GRID_ROLE_CD: TGridSchema = {
    id: "grid",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "40%" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
    ],
    body: [
        {
            cells: [{ binding: "roleId" }],
        },
        {
            cells: [{ binding: "roleNm", align: "left" }],
        },
    ],
};
